import React, { useLayoutEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { completedComponentState } from '../../stores/completedComponentState';
import { pageState } from '../../stores/pageState';
import { currentScenarioItemState } from '../../stores/displayedScenarioItemState';

export interface MessageProps {
  componentId: string;
  message: string;
  size?: 'small' | 'normal' | 'large';
}

const Message: React.FC<MessageProps> = props => {
  const setCompleted = useSetRecoilState(completedComponentState(props.componentId));
  const currentItem = useRecoilValue(currentScenarioItemState);
  const page = useRecoilValue(pageState);

  const isCurrent = currentItem?.components.find(c => c.id === props.componentId);
  useLayoutEffect(() => {
    if (page.location === 'preview') return;
    if (isCurrent) {
      const id = setTimeout(() => setCompleted(true), 1000)
      return () => {
        clearTimeout(id);
      }
    }
  }, [page.location, props.componentId, setCompleted, isCurrent]);
  const regexpUrl = /(https?:\/\/[\w~!#$-/:;=?@()]+)/g;
  return (<p className={["message", props.size === 'small' && 'small', props.size === 'large' && 'large'].filter(c => c).join(' ')}>
    {props.message.split(regexpUrl).map((text, i) => {
      if (regexpUrl.test(text)) {
        return <a key={i} href={text} target="_blank" rel="noopener noreferrer">{text}</a>;
      } else {
        return <React.Fragment key={i}>{text}</React.Fragment>
      }
    })}
  </p>);
};

export default Message;
